import { Typography, Grid, InputLabel } from "@material-ui/core";
import React from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  StripeProvider,
  Elements,
  injectStripe,
} from "react-stripe-elements";
import "./Checkout.css";

const createOptions = (fontSize, padding) => {
  return {
    hidePostalCode: true,
    style: {
      base: {
        fontSize,
        color: "#424770",
        letterSpacing: "0.025em",
        fontFamily: "Source Code Pro, monospace",
        "::placeholder": {
          color: "#aab7c4",
        },
        padding,
      },
      invalid: {
        color: "#9e2146",
      },
    },
  };
};

class _CardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {},
      disableButton: false,
    };
  }
  handleSubmit = (ev) => {
    ev.preventDefault();
    if (this.props.stripe) {
      this.props.stripe.createToken().then((payload) => {
        if (payload?.token) {
          this.setState({ error: {} });
          this.props.handlePayment(payload?.token);
          setTimeout(() => {
            this.setState({ disableButton: false });
          }, 2000);
        } else {
          this.setState({ error: payload?.error });
          this.setState({ disableButton: false });
        }
      });
    } else {
      this.setState({ disableButton: false });
    }
  };
  render() {
    return (
      <>
        <Typography component="p" style={{ color: "#fff", textAlign: "left" }}>
          Card details
        </Typography>
        <form className="checkout-form" onSubmit={this.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item sm="12" xs="12" md="12">
              <InputLabel className="label-stripe">Card Number</InputLabel>
              <CardNumberElement
                className="input-stripe"
                {...createOptions(this.props.fontSize)}
              />
            </Grid>
            <Grid
              item
              sm="12"
              xs="12"
              md="6"
              style={{
                marginTop: "20px",
              }}
            >
              <InputLabel className="label-stripe">Expiration Date</InputLabel>
              <CardExpiryElement
                className="input-stripe"
                {...createOptions(this.props.fontSize)}
              />
            </Grid>
            <Grid item sm="12" xs="12" md="6" style={{ marginTop: "20px" }}>
              <InputLabel className="label-stripe">CVV</InputLabel>
              <CardCVCElement
                className="input-stripe"
                {...createOptions(this.props.fontSize)}
              />
            </Grid>
            {this.state?.error?.message && (
              <span className="payment-error stripe-error">
                {this.state?.error?.message}
              </span>
            )}
            <Grid item sm="12" xs="12" md="12">
              <button
                className="pay-btn"
                disabled={this.state.disableButton}
                onClick={(ev) => {
                  this.setState({
                    disableButton: true,
                  });
                  this.handleSubmit(ev);
                }}
              >
                {this.props.price}
              </button>
            </Grid>
          </Grid>
        </form>
      </>
    );
  }
}
const CardForm = injectStripe(_CardForm);

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elementFontSize: window.innerWidth < 450 ? "14px" : "18px",
    };
    window.addEventListener("resize", () => {
      if (window.innerWidth < 450 && this.state.elementFontSize !== "14px") {
        this.setState({ elementFontSize: "14px" });
      } else if (
        window.innerWidth >= 450 &&
        this.state.elementFontSize !== "18px"
      ) {
        this.setState({ elementFontSize: "18px" });
      }
    });
  }

  render() {
    const { elementFontSize } = this.state;
    return (
      <div className="Checkout">
        <Elements>
          <CardForm
            fontSize={elementFontSize}
            handlePayment={this.props.handlePayment}
            price={this.props.price}
          />
        </Elements>
      </div>
    );
  }
}
const StripeCheckout = ({ handlePayment, price }) => {
  return (
    <div className="strip-checkout" style={{ width: "100%", padding: 0 }}>
      <StripeProvider apiKey="pk_live_51Hz8rWAPZBObyWA9ZpO4SmWXN9wAQZBGVSdMY7mQYE3GwfDmU0AE4y9L4pAF852i7er3EI60mN7z1CMdDXejngeo00uGtIdOMW">
        <Checkout handlePayment={handlePayment} price={price} />
      </StripeProvider>
    </div>
  );
};

export default StripeCheckout;
